import { Loader2 } from 'lucide-react';
import { Pie, PieChart, ResponsiveContainer, Tooltip, type TooltipProps } from 'recharts';

import { useGetAccountsReceivableDueDateGrouping } from '~entities/dashboard/api/get-accounts-receivable-due-date-grouping';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const TooltipLabel = {
  '0-30d': 'Less than 30 days',
  '31-60d': '31-60 Days',
  '61-90d': '61-90 Days',
  '90+d': 'Over 90 Days',
};

interface PieChartData {
  name: string;
  value: number;
  fill: string;
}

// Custom tooltip component
const CustomTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (active && payload && payload.length > 0 && payload[0]) {
    const name = payload[0].name;
    const value = payload[0].value;

    return (
      <div className='rounded-lg border border-gray-300 bg-white p-1 shadow-lg'>
        <p className='text-xs text-gray-800'>
          {TooltipLabel[name as keyof typeof TooltipLabel]}
          {/* {name} */}
        </p>
        <p className='text-xs text-gray-600'>{value ?? 0}%</p>
      </div>
    );
  }
  return null;
};

interface AccountReceivablePieChartProps {
  sessionId: string;
}

export const AccountReceivablePieChart = ({
  sessionId,
}: AccountReceivablePieChartProps) => {
  const {
    data: accountsReceivableDueDateGrouping,
    isFetching: isAccountsReceivableDueDateGroupingFetching,
  } = useGetAccountsReceivableDueDateGrouping({ sessionId });
  // Remove console.log for production code

  const data: Array<PieChartData> =
    accountsReceivableDueDateGrouping?.map((item, index) => ({
      name: item.label,
      value: item.percentage,
      fill: COLORS[index % COLORS.length] ?? '#000000',
    })) ?? [];

  return (
    <div className='relative aspect-square h-full w-full min-w-0 max-w-full'>
      {isAccountsReceivableDueDateGroupingFetching ? (
        <div className='flex h-full items-center justify-center'>
          <Loader2 className='size-4 animate-spin' />
        </div>
      ) : (
        <ResponsiveContainer width='100%' height='100%' minWidth={0}>
          <PieChart>
            <Pie
              data={data}
              innerRadius='80%'
              outerRadius='100%'
              cornerRadius='50%'
              fill='#8884d8'
              dataKey='value'
              isAnimationActive
            />
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
